<template>
  <b-table-lite
    striped
    small
    responsive
    :items="data"
    class="mb-0"
    thead-class="hidden"
  >
    <template v-slot:cell(value)="{ item }">
      <pre class="value">{{ item.value }} </pre>
    </template>
  </b-table-lite>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { flattenKeys } from '@/utils';

export default defineComponent({
  name: 'AdapterSummary',
  props: {
    value: {
      type: Object as () => { key: string; value: any },
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    data() {
      return Object.entries(flattenKeys(this.value))
        .filter(item => !!item[1])
        .map(([key, value]) => ({ key, value }));
    },
  },
});
</script>

<style scoped>
.value {
  margin: 0;
  white-space: pre-line;
}
</style>
